<template>
  <v-container class="app-list mb-3" fluid grid-list-xl>
    <div v-if="selected.length || tableTitle" class="table-title">
      <div class="title-wrapper">
        <div v-if="tableTitle" class="title">{{ tableTitle }}</div>
        <div v-if="selected.length && counterText" class="counter">
          {{ select.length }} {{ counterText }}
        </div>
      </div>

      <span v-if="selected.length" @click="onDelete" class="selected-text">
        {{ selectedText }}
      </span>
    </div>

    <v-layout row wrap>
      <v-flex v-for="(item, index) in items" :key="index" xs12 sm6 md4 lg3>
        <v-toolbar color="secondary" flat>
          <v-toolbar-title class="d-flex white--text">
            <v-checkbox
              v-if="checkboxTable"
              primary
              hide-details
              :input-value="item.selected"
              :value="true"
              :value-comparator="() => !!item.selected"
              @change="selectPropsIfCan($event, item)"
            >
            </v-checkbox>
            <span v-html="onTitle(item)" class="pt-2 pb-2"></span>
          </v-toolbar-title>

          <v-spacer></v-spacer>

          <template v-if="options">
            <v-menu
              v-if="options.options(item).length"
              origin="center center"
              transition="scale-transition"
              bottom
              left
            >
              <v-btn slot="activator" icon id="btn-more-vert-app-list">
                <v-icon class="white--text">more_vert</v-icon>
              </v-btn>
              <v-list>
                <v-list-tile
                  v-for="(option, jndex) in options
                    .options(item)
                    .filter(option => option.show === undefined || option.show === true)"
                  :key="jndex"
                  @click="emit(option.method, item, index)"
                >
                  <v-list-tile-title v-bind:id="option.id">{{
                    option.title
                  }}</v-list-tile-title>
                </v-list-tile>
              </v-list>
            </v-menu>
          </template>
        </v-toolbar>

        <v-card flat>
          <v-list dense>
            <v-list-tile v-for="header in filteredHeaders" :key="header.text">
              <v-list-tile-content>
                <div>
                  <span>{{ header.text }}</span>

                  <v-tooltip top v-if="header.tooltip">
                    <v-icon small slot="activator">{{
                      header.tooltipIcon || 'info'
                    }}</v-icon>
                    <span>{{ header.tooltip }}</span>
                  </v-tooltip>
                </div>
              </v-list-tile-content>

              <v-list-tile-content class="align-end">
                <v-icon
                  v-if="header.icon"
                  :class="iconClasses(header, item)"
                  @click.stop="onActionIcon(header, item)"
                >
                  {{ getIcon(header, item) }}
                </v-icon>
                <v-progress-linear
                  v-else-if="header.progress"
                  background-color="#E0E0E0"
                  color="#299D8D"
                  :value="header.progress(item)"
                ></v-progress-linear>
                <div v-else-if="header.formatter" v-html="header.formatter(item)">
                </div>
                <div 
                  v-if="header.toggle"
                >
                  <v-switch
                    class="table-toggle"
                    color="secondary"
                    @change="$emit('onToggle', item)"
                    v-model="item[header.value]"
                  />
                </div>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: 'AppList',

  props: {
    tableTitle: String,
    headers: {
      type: Array
    },
    items: {
      type: Array
    },
    checkboxTable: Boolean,
    selected: {
      type: Array,
      default: () => []
    },
    counterText: {
      type: String,
      default: () => ''
    },
    selectedText: {
      type: String,
      default: 'Excluir'
    }
  },

  data: () => ({ select: [] }),

  computed: {
    filteredHeaders() {
      return this.headers.filter(item => item.value !== 'options' && item.show !== false)
    },
    options() {
      return this.headers.find(item => item.value === 'options')
    },
  },

  methods: {
    getIcon(header, item) {
      return header?.icon(item)?.type
    },

    onTitle(item) {
      try {
        const hasTitle = this.headers.find(({ asTitle }) => asTitle).formatter(item)
        return hasTitle
      } catch (error) {
        return this.headers.find((item, index) => index === 0).formatter(item)
      }
    },

    iconClasses(header, item) {
      return [
        `mr-1 ${header.icon(item).color}`,
        { 'primary--text': !this.selected.some(({ _id }) => _id === item._id) },
        `icon-${header.icon(item).iconColor}`
      ]
    },

    onActionIcon(header, item) {
      const eventName = header?.event
      if (!eventName) return

      const selected = this.selected.some(({ _id }) => _id === item._id)
      if (selected) return

      this.$emit(eventName, { header, item })
    },

    onDelete() {
      this.$emit('onDelete', this.select)
    },

    emit(method, item, index) {
      // TODO: remove this event
      this.$emit('onOption', { method, item, index })

      this.$emit(method, item, index)
    },

    selectPropsIfCan(checked, item) {
      this.select = [...this.select, item]
      item.selected = true

      if (!checked) {
        this.select = this.select.filter(({ _id }) => _id !== item._id)
        item.selected = false
      }

      this.$emit('table:selected-item', this.select)
    }
  }
}
</script>

<style lang="stylus">
.app-list
  .v-toolbar
    .v-toolbar__content
      height: 60px !important;

  padding: 0px;

  .v-input--selection-controls__input > .accent--text
    color: rgba(0,0,0,0.2) !important

  .icon-green {
    color: #27AE60 !important;
  }

  .icon-yellow {
    color: #FF9800 !important;
  }

  .icon-red {
    color: #EB5757 !important;
  }
</style>
